import { table } from './_table';

export const documents = {
  namespaced: true,
  modules: {
    table
  }
};
